// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"aa8f2baa","977":"b0d902a7"}[chunkId] + ".chunk.js";
};